import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function ClinicSubscriptions({ user }) {
    const [plans, setPlans] = useState([]);
    const [currentPlanId, setCurrentPlanId] = useState(null);
    const [subscriptionEnd, setSubscriptionEnd] = useState(null);
    const [currentCounts, setCurrentCounts] = useState({ admin: 0, doctor: 0, staff: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Planları çek
        axios.get('./backend/get_plans.php')
            .then(res => setPlans(Array.isArray(res.data) ? res.data : []))
            .catch(err => console.error(err));

        // Mevcut kliniğin planını öğrenmek için settings'den veya login user'dan bilgi alabiliriz
        // Ancak en doğrusu backend'den taze veri çekmek.
        // Basitlik için user objesindeki clinic_id ile settings çekip oradan planı bulmak zor olabilir çünkü settings tablosunda plan_id yok.
        // Bu yüzden get_settings.php'ye plan_id eklemek veya ayrı bir endpoint yapmak lazım.
        // Pratik çözüm: get_settings.php zaten clinic tablosuyla join yapıyor mu? Bakalım.
        // get_settings.php sadece settings ve clinics.is_active çekiyor.
        // En iyisi burada basit bir endpoint simülasyonu veya mevcut bir endpointi kullanmak.
        // Login olurken user objesine plan_id ekleyebiliriz ama anlık değişim görünmez.
        // Şimdilik settings endpointini güncelleyelim veya varsayalım.
        // Doğrusu: get_settings.php'yi güncelleyip plan_id'yi de döndürmek.
        
        axios.get('./backend/get_settings.php')
            .then(res => {
                // Not: get_settings.php'yi güncellememiz gerekecek (Aşağıda yapacağım)
                if (res.data && res.data.plan_id) {
                    setCurrentPlanId(parseInt(res.data.plan_id));
                    setSubscriptionEnd(res.data.subscription_end);
                }
                if (res.data && res.data.current_counts) {
                    setCurrentCounts(res.data.current_counts);
                }
                setLoading(false);
            });
    }, []);

    const handleUpgradeRequest = (planId) => {
        if (window.confirm("Bu pakete geçiş talebi oluşturmak istiyor musunuz?")) {
            axios.post('./backend/request_upgrade.php', { requested_plan_id: planId })
                .then(res => toast.success(res.data.message))
                .catch(err => toast.error(err.response?.data?.message || "Talep oluşturulamadı."));
        }
    };

    const checkLimits = (plan) => {
        const issues = [];
        // -1 limitsiz anlamına gelir
        if (parseInt(plan.max_admins) !== -1 && currentCounts.admin > parseInt(plan.max_admins)) {
            issues.push(`Yönetici (${currentCounts.admin} > ${plan.max_admins})`);
        }
        if (parseInt(plan.max_doctors) !== -1 && currentCounts.doctor > parseInt(plan.max_doctors)) {
            issues.push(`Doktor (${currentCounts.doctor} > ${plan.max_doctors})`);
        }
        if (parseInt(plan.max_staff) !== -1 && currentCounts.staff > parseInt(plan.max_staff)) {
            issues.push(`Personel (${currentCounts.staff} > ${plan.max_staff})`);
        }
        return issues;
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Abonelik Paketleri</h2>
                {subscriptionEnd && (
                    <div style={{background: '#e3f2fd', padding: '10px 20px', borderRadius: '20px', color: '#0d47a1', fontWeight: 'bold'}}>
                        Bitiş Tarihi: {new Date(subscriptionEnd).toLocaleDateString()}
                    </div>
                )}
            </div>

            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {plans.map(plan => {
                    const isCurrent = parseInt(plan.id) === currentPlanId;
                    const issues = checkLimits(plan);
                    const isEligible = issues.length === 0;
                    return (
                        <div key={plan.id} style={{
                            background: 'white',
                            borderRadius: '15px',
                            padding: '30px',
                            boxShadow: isCurrent ? '0 0 0 4px #4e73df' : '0 10px 30px rgba(0,0,0,0.1)',
                            width: '300px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            borderTop: `5px solid ${plan.color || '#4e73df'}`,
                            position: 'relative'
                        }}>
                            {isCurrent && <div style={{position: 'absolute', top: '-15px', background: '#4e73df', color: 'white', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold'}}>MEVCUT PAKET</div>}
                            <h3 style={{ margin: '10px 0', color: '#333', fontSize: '1.5rem' }}>{plan.name}</h3>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: plan.color || '#4e73df', marginBottom: '5px' }}>
                                {parseFloat(plan.price).toLocaleString('tr-TR')} ₺
                            </div>
                            <div style={{fontSize: '0.8rem', color: '#888', marginBottom: '20px'}}>
                                {parseInt(plan.price_includes_vat) ? 'KDV Dahil' : '+ KDV'} / {plan.billing_cycle === 'yearly' ? 'Yıl' : 'Ay'}
                            </div>
                            
                            <ul style={{ listStyle: 'none', padding: 0, width: '100%', marginBottom: '30px' }}>
                                <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Yönetici</span> <strong>{plan.max_admins === '-1' ? 'Sınırsız' : plan.max_admins}</strong>
                                </li>
                                <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Doktor</span> <strong>{plan.max_doctors === '-1' ? 'Sınırsız' : plan.max_doctors}</strong>
                                </li>
                                <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Personel</span> <strong>{plan.max_staff === '-1' ? 'Sınırsız' : plan.max_staff}</strong>
                                </li>
                                {plan.features && plan.features.split('\n').map((feature, idx) => (
                                    <li key={idx} style={{ padding: '5px 0', fontSize: '0.9rem', color: '#555', display: 'flex', alignItems: 'center' }}>
                                        <span style={{color: '#1cc88a', marginRight: '5px'}}>✓</span> {feature}
                                    </li>
                                ))}
                            </ul>
                            
                            {!isCurrent && (
                                isEligible ? (
                                    <button className="add-btn" onClick={() => handleUpgradeRequest(plan.id)} style={{ width: '100%', justifyContent: 'center' }}>Paket Yükselt</button>
                                ) : (
                                    <div style={{color: '#e74a3b', fontSize: '0.8rem', textAlign: 'center', background: '#fff5f5', padding: '10px', borderRadius: '5px', border: '1px solid #ffcdd2'}}>
                                        <strong>Paket Yetersiz</strong><br/>
                                        {issues.join(', ')}<br/>
                                        <small>Kullanıcı sayısını azaltmalısınız.</small>
                                    </div>
                                )
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ClinicSubscriptions;